import { useModelReady } from './useModelReady';

// True while the given model's background sync has not yet completed. Phased load
// is always on: the app unblocks once essential master-data is ready and heavy
// models (SSCC / TripSheet) keep syncing. Use this to gate affordances that read
// the full synced set of a heavy model; leave create/by-id/direct-API affordances
// ungated.
export function usePhasedModelGate(modelName: string): { loading: boolean } {
  const isReady = useModelReady(modelName);
  return { loading: !isReady };
}
